import { nanoid } from 'nanoid'

class ModelFaqDetail {
    constructor({faqID, questionBody, answerBody}) {
        this.id = faqID;
        this.key = nanoid();
        this.question = questionBody;
        this.answer = answerBody;
    }
}
export default ModelFaqDetail;